let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e3XdD")).then(() => parcelRequire('6kXBX'));